<template>
  <div class="radioBtn">
    <el-radio-group @change="defaultChange" v-model="defaul" size="small">
      <el-radio-button
        v-for="(item, index) in list"
        :key="index"
        :label="item.label"
      >{{item.value}}</el-radio-button>
    </el-radio-group>
  </div>
</template>
<script>
export default {
  props: ["list", "default"],
  data() {
    return {
      defaul: "1",
    };
  },
  watch:{
    default(e){
      this.defaul=e
    }
  },
  created() {
      this.defaul=this.default
  },
 methods:{
     defaultChange(){
         this.$emit('defaulchange',this.defaul)
     }
 }
};
</script>
<style lang="scss" scoped>
.el-radio-group {
  .el-radio-button {
    margin-right: 0.8rem;
    border-left: 1px solid #dcdfe6;
    border-radius: 0.1rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Denominated/radioBtn.vue